import { render } from "./Pm.vue?vue&type=template&id=cd413a76&scoped=true"
import script from "./Pm.vue?vue&type=script&lang=js"
export * from "./Pm.vue?vue&type=script&lang=js"

import "./Pm.vue?vue&type=style&index=0&id=cd413a76&lang=css"
import "./Pm.vue?vue&type=style&index=1&id=cd413a76&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd413a76"]])

export default __exports__